import GroupsManagerDashboard from "./GroupsManagerDashboard"

export default  GroupsManagerDashboard;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/index.js